export default "__VITE_ASSET__DWdEUZGA__"